import { FileExcelOutlined, LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import { Flex, Upload, message } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as XLSX from 'xlsx';
import './index.less'
import Loader from "@/components/Loader";
import CountUp from 'react-countup';
import { cdnUrl } from '@/utils/cdn';

const UploadFormChild = (props: any) => {
  const { t } = useTranslation()
  const { onDone } = props
  const [loading, setLoading] = useState(false);
  const [num, setNum] = useState<any>(0);
  const [data, setData] = useState<any>([]);

  const customRequest = async (item: any) => {
    setLoading(true);
    console.log(item);
    const { file } = item;
    const fileType = file.type;
    const fileName = file.name;
  
    const reader = new FileReader();
  
    reader.onload = (e: any) => {
      let data: any;
      let str = '';
  
      if (fileType === 'application/json' || fileName.endsWith('.json')) {
        data = JSON.parse(e.target.result);
        // 假设 JSON 结构是数组的话
      } else if (fileType.includes('text/csv') || fileName.endsWith('.csv') || fileType.includes('text/plain') || fileName.endsWith('.txt') || fileType.includes('application/vnd.ms-excel') || fileType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || fileName.endsWith('.xls') || fileName.endsWith('.xlsx')) {
        // Excel 或 CSV 文件处理
        const ab = e.target.result;
        const wb = XLSX.read(ab, {type: 'array'});
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        data = XLSX.utils.sheet_to_json(ws);
      }
  
      console.log(data);
  
      // 这里的处理假设所有文件类型都最终转化为了JSON数组来处理
      // 你可以根据实际情况调整这部分逻辑
      if (data) {
        let tmp = 0
        data.forEach((item: any, index:number) => {
          if (item.PrivateKey) {
            str += `${item.PrivateKey}${data.length - 1 === index ? '' : '\n'}`;
            tmp += (1 / data.length) * 100
            setNum(tmp)
          }
        });
        setNum(100)
        onDone && onDone(str);
      }
      setData(data);

      setLoading(false);
  
       
    };
  
    if (fileType === 'application/json' || fileName.endsWith('.json')) {
      reader.readAsText(file); // 读取 JSON 文件
    } else {
      reader.readAsArrayBuffer(file); // 读取 Excel 或 CSV 文件
    }
  };
  
  

const fileTypes = [
  'text/csv', // CSV 文件
  'text/plain', // TXT 文件
  'application/json', // JSON 文件
  'application/vnd.ms-excel', // Excel 文件 (.xls)
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel 文件 (.xlsx)
];


  const beforeUpload = (file: any) => {
    const isAllowed = fileTypes.includes(file.type) ||
                      file.name.endsWith('.csv') ||
                      file.name.endsWith('.txt') ||
                      file.name.endsWith('.json') ||
                      file.name.endsWith('.xlsx') ||
                      file.name.endsWith('.xls');

    if (!isAllowed) {
      message.error( t("components.onlyUploadCSV_TXT_JSON_Or_Excel"));
    }
    // 如果不想自动上传，而是手动处理文件，可以在这里返回 false
    return isAllowed ? true : Upload.LIST_IGNORE;
  };

  const accept = "*"

  const uploadButton = (
    <>
      <button className='up-btn' style={{ border: 0, background: 'none' }} type="button">
        <Flex justify="center" align="center"><img style={{ width: '16px' }} src={cdnUrl("/img/upload-icon.svg")} alt="" /><span className="txt">{t("components.uploadFile")}</span></Flex>
      </button>
    </>
  );

  function InputLoading({ loading, num }: any) {
    if (loading) {
      return  <div className="loading-number">
      <Loader>
      <img src={cdnUrl("/img/eth/loading-blue.webp")} alt="" />
    </Loader>
    <div className="percent">
    <CountUp end={num} /><span>%</span>
    </div>
    
    </div>
      
    } 

    return <p className='drag-tips'>{ t("components.dragFileHereOrClickToUpload") }</p>
  }

  // useEffect(() => {
  //   setLoading(true)
  //   setTimeout(() => {
  //     setNum(100)
  //   }, 5000)
  // }, [])

  return (
    <div className='upload-excel-card'>
      {/* <Input value={logo}  placeholder='请输入Token URL'/> */}
      <div className='upload-child'>
        <Upload
          customRequest={customRequest}
          accept={accept}
          maxCount={1}
          beforeUpload={beforeUpload}
          showUploadList={false}
          listType="picture-card">
          {data.length > 0 ? <FileExcelOutlined /> : uploadButton}
        </Upload>
        <InputLoading  loading={loading} num={num} />
        
        <p className='file-type-tips'>&lt; { t("components.supportedFileTypes") } &gt;</p>
      </div>
    </div>
  )
}

export default UploadFormChild